import { render, staticRenderFns } from "./CollectionItem.vue?vue&type=template&id=75eb4ee3&scoped=true&"
import script from "./CollectionItem.vue?vue&type=script&lang=js&"
export * from "./CollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItem.vue?vue&type=style&index=0&id=75eb4ee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eb4ee3",
  null
  
)

export default component.exports